module.exports = __webpack_public_path__ + "static/media/poster_1.b76c84b2.png";